module.exports = __webpack_public_path__ + "img/cd86fc6.jpg";